module.exports = __webpack_public_path__ + "img/yyxm.5159e989.svg";